module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4561a51c20e7ea23d6eba9b68f179420.png";